import { doc, onSnapshot } from "firebase/firestore";
import { useEffect, useState } from "react";

import { ATOMS } from "../../recoil/atom";
import { createSnackBarContent } from "../global/useSnackBar";
import { fireDatabase } from "../../config/firebase";
import { needRequestCollections } from "../../constants/access";
import useNeedRequestVisibilityHelper from "../data/useNeedRequestVisibilityHelper";
import { useSetAtom } from "jotai";
import { useTranslation } from "react-i18next";

const collectionRequired = [needRequestCollections.POIS];

const usePointOfInterest = () => {
  const { t } = useTranslation(["snackbar"]);

  const popSnackbar = useSetAtom(ATOMS.SNACKBAR);
  const setPoisList = useSetAtom(ATOMS.POI_LIST);
  const setPoisTypes = useSetAtom(ATOMS.POI_TYPES);

  const [unSubscribe, setUnSubscribe] = useState<(() => void) | null>(null);

  const canLoadData = useNeedRequestVisibilityHelper(() => {
    unSubscribe && unSubscribe();
  }, collectionRequired);

  // Point of interest list and types
  useEffect(() => {
    if (canLoadData) {
      const unsub = onSnapshot(
        doc(fireDatabase, "map", "points_of_interest"),
        (doc) => {
          setPoisList(doc.data()?.POI ?? []);
          setPoisTypes(doc.data()?.POI_types ?? []);
        },
        (err) => {
          console.error(err);
          popSnackbar(
            createSnackBarContent({
              content: t("snackbar:request_pois_error"),
              severity: "error",
            }),
          );
          setPoisList([]);
          setPoisTypes([]);
        },
      );
      setUnSubscribe(() => unsub);
      return () => unsub();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canLoadData]);

  return null;
};

export default usePointOfInterest;
